var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFxs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1 4.97 4.243 3.997a12.588 12.588 0 0 0-2.037 6.886c0 2.617.795 5.049 2.157 7.067L1 27.03 4.676 31l4.74-4.259a12.588 12.588 0 0 0 6.437 1.76c2.424 0 4.69-.682 6.614-1.865L27.324 31 31 27.03l-4.544-4.28a12.588 12.588 0 0 0 2.044-6.897c0-2.466-.706-4.767-1.926-6.713L31 4.97 27.323 1 22.66 5.192a12.588 12.588 0 0 0-6.807-1.986c-2.433 0-4.705.687-6.633 1.877L4.676 1 1 4.97zm14.853 18.677a7.794 7.794 0 1 0 0-15.588 7.794 7.794 0 0 0 0 15.587z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxs);
export default __webpack_public_path__ + "static/media/FXS.2c31c4a6c5e613fedb6ced7c00b709a3.svg";
export { ForwardRef as ReactComponent };